<template>
  <div
    v-if="shouldRenderConfig && !getIsMyAccount && getShowConnectButton"
    :class="getClassName"
  >
    <button
      type="button"
      class="btn btn-primary"
      :class="getDisableClass"
      @click="connectButton"
    >
      {{ $t(name) }}
    </button>
  </div>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useMyAccountStore } from "@/stores/modules/myAccount";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useWebproductStore, [
      "getShowConnectButton",
      "getFilesConnectLoading"
    ]),
    ...mapState(useMyAccountStore, ["getIsMyAccount"]),
    name: function () {
      return "Connect";
    },
    getDisableClass: function () {
      return this.getFilesConnectLoading ? "disable" : "";
    }
  },
  methods: {
    ...mapActions(useWebproductStore, ["connectUploads"]),
    connectButton: function () {
      this.connectUploads({ widget: this });
    }
  }
};
</script>
